/* Quiz DB engine: shows one screen of window.QZ_SCREENS at a time on a single Shopify page.
 * Each screen keeps its own HTML, CSS and script from Funnelish. Only the current screen is in the DOM,
 * so the class names and ids that the screens share never clash. Step number is kept in ?step=N,
 * so the browser back button works and analytics see one page view per step. */
(function () {
  if (window.__qzEngine) return;
  window.__qzEngine = true;
  var root = document.getElementById('qz-root');
  var screens = window.QZ_SCREENS || [];
  var base = window.QZ_ASSET_BASE || '';
  var finalUrl = window.QZ_FINAL_URL || '';
  var total = screens.length;
  var current = 0;
  if (!root || !total) return;

  function stepFromUrl() {
    var n = parseInt(new URLSearchParams(window.location.search).get('step'), 10);
    return n >= 1 && n <= total ? n : 1;
  }

  function urlForStep(n) {
    var u = new URL(window.location.href);
    if (n === 1) u.searchParams.delete('step'); else u.searchParams.set('step', n);
    return u.pathname + u.search + u.hash;
  }

  // Run the screen's scripts as if the page had just loaded (DOMContentLoaded handlers run at once).
  function runScripts(container) {
    var add = document.addEventListener;
    document.addEventListener = function (type, fn, opts) {
      if (type === 'DOMContentLoaded') { setTimeout(fn, 0); return; }
      return add.call(document, type, fn, opts);
    };
    try {
      container.querySelectorAll('script').forEach(function (old) {
        var s = document.createElement('script');
        for (var i = 0; i < old.attributes.length; i++) s.setAttribute(old.attributes[i].name, old.attributes[i].value);
        s.textContent = old.textContent;
        old.parentNode.replaceChild(s, old);
      });
    } finally {
      document.addEventListener = add;
    }
  }

  // Changes made in the theme editor (section blocks "Step N"): texts line by line, pictures by position.
  function applyEdits(n) {
    var el = document.getElementById('qz-edits'), all;
    if (!el) return;
    try { all = JSON.parse(el.textContent); } catch (e) { return; }
    var ed = all[n];
    if (!ed) return;
    if (ed.texts) {
      var lines = ed.texts.replace(/\r/g, '').split('\n'), i = 0, node;
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, { acceptNode: function (t) { return t.parentElement.closest('script,style,noscript,template') || !t.textContent.trim() ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT; } });
      var nodes = [];
      while ((node = w.nextNode())) nodes.push(node);
      nodes.forEach(function (t) {
        var want = lines[i++];
        if (want == null) return;
        want = want.trim();
        var orig = t.textContent.replace(/\s+/g, ' ').trim();
        if (want && want !== orig) t.textContent = t.textContent.match(/^\s*/)[0] + want + t.textContent.match(/\s*$/)[0];
      });
    }
    if (ed.imgs) {
      var imgs = root.querySelectorAll('img');
      ed.imgs.forEach(function (u, k) {
        if (!u || !imgs[k]) return;
        imgs[k].removeAttribute('srcset'); imgs[k].removeAttribute('data-src'); imgs[k].removeAttribute('data-srcset');
        imgs[k].src = u;
      });
    }
  }

  function render(n) {
    current = n;
    window.__qzPage = n;
    root.innerHTML = screens[n - 1].split('__QZA__').join(base);
    applyEdits(n);
    if (finalUrl && n === total) {
      root.querySelectorAll('a[href*="primal-storm.com/products/primal-storm"]').forEach(function (a) { a.setAttribute('href', finalUrl); });
    }
    runScripts(root);
    window.scrollTo(0, 0);
  }

  function go(n, replace) {
    n = Math.max(1, Math.min(total, n));
    if (n === current) return;
    var url = urlForStep(n);
    if (replace) history.replaceState({ qzStep: n }, '', url); else history.pushState({ qzStep: n }, '', url);
    render(n);
    // Funnelish fired a page_view per step page; GTM gets the same per step here
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'page_view', url: window.location.href, quiz_step: n });
    // PostHog's history_change pageviews ignore query-only changes, so ?step=N needs its own $pageview
    if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture('$pageview', { quiz_step: n });
  }
  window.__qzGo = function (n) { go(n); };

  // Links to /page-N of the Funnelish funnel are steps of this quiz. No root.contains() check on purpose:
  // a link of a screen that was just swapped out is detached, and must still not leave for Funnelish.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var m = a.getAttribute('href').match(/\/quiz-[\w-]+\/page-(\d+)/);
    if (!m) return;
    e.preventDefault();
    go(parseInt(m[1], 10));
  });

  window.addEventListener('popstate', function () { render(stepFromUrl()); });

  // Theme editor: selecting a "Step N" block shows that step; a changed setting re-renders the section, so show the step again.
  document.addEventListener('shopify:block:select', function (e) {
    var s = e.target && e.target.getAttribute && parseInt(e.target.getAttribute('data-qz-step'), 10);
    if (s) go(s);
  });
  document.addEventListener('shopify:section:load', function () {
    var r = document.getElementById('qz-root');
    if (r && r !== root) { root = r; var n = current; current = 0; render(n || 1); }
  });

  var first = stepFromUrl();
  history.replaceState({ qzStep: first }, '', window.location.href);
  render(first);
})();
